// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/ProductionOperators_GenerateQrcodeResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * Response Contract for GET /so/production_operators/gerar_qrcode
 *
 * Generates a unique badge QR code string in the format
 * OP-{timestamp}-{random8}. Wire shape: `dados: string`.
 *
 * @see So_production_operators_model::gerarQrcode()
 */
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export type ProductionOperators_GenerateQrcodeResponseDados = string;

export type ProductionOperators_GenerateQrcodeResponse = ApiResponse<ProductionOperators_GenerateQrcodeResponseDados>;

registerResponseContract('ProductionOperators_GenerateQrcodeResponse', {})
